<template>
  <div class="flex h-full min-h-0 flex-col gap-6">
    <WarningDisable permission="system_cmd" />
    <div class="flex min-h-0 min-w-0 flex-1 flex-col">
      <div class="mb-2 flex items-baseline justify-between">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Lịch sử chạy lệnh
        </div>
        <CreateCmd />
      </div>
      <div role="tablist" class="tabs tab-tab">
        <button
          role="tab"
          class="tab"
          :class="{ 'tab-active': activeTab === 'history' }"
          @click="activeTab = 'history'"
        >
          Lịch sử chạy lệnh
        </button>
        <button
          role="tab"
          class="tab"
          :class="{ 'tab-active': activeTab === 'terminal' }"
          @click="openTerminal"
        >
          Terminal tương tác
        </button>
      </div>

      <div v-if="activeTab === 'history'" class="mt-4">
        <Loading v-if="action_store.loading.get_action_history" />
        <CommandLineHistoryTable
          v-else-if="action_store.total_filter > 0"
          :actions="action_store.actions"
          :total_pages="action_store.total_pages"
          :show_cmd_info="show_cmd_info"
        />
        <NotFound v-else />
      </div>

      <TerminalPanel
        v-else
        :state="
          terminal.failed
            ? 'failed'
            : terminal.creating
              ? 'loading'
              : 'connected'
        "
        @retry="createTerminal"
      >
        <ClientTerminal
          v-if="terminal.actionId"
          :action-id="terminal.actionId"
          @close="resetTerminal"
        />
      </TerminalPanel>
    </div>
  </div>
  <ResultModal
    :loading="cmd_store.loading.get_cmd_info"
    :args="cmd_store.selected_cmd?.action.args"
    :result="cmd_store.selected_cmd?.result.data"
  />
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { axios_instance } from "@/api/api";
import { useRouter } from "vue-router";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import TerminalPanel from "@/components/ClientDetail/Terminal/TerminalPanel.vue";
import { ClientTerminal } from "@/components/ClientDetail/Terminal";
import { use_action } from "../ExplorerV2/useAction";
import WarningDisable from "../WarningDisable.vue";
import ResultModal from "./CmdResultModal.vue";
import CommandLineHistoryTable from "./CommandLineHistoryTable.vue";
import CreateCmd from "./CreateCmd.vue";
import { use_cmd } from "./useCmd";

const action_store = use_action();
const cmd_store = use_cmd();
const router = useRouter();
const activeTab = ref<"history" | "terminal">("history");
const terminal = reactive({ actionId: "", creating: false, failed: false });

function openTerminal() {
  activeTab.value = "terminal";
  if (!terminal.actionId && !terminal.creating) void createTerminal();
}

async function createTerminal() {
  const clientId = router.currentRoute.value.params.client_id as string;
  if (!clientId || terminal.creating) return;

  terminal.actionId = "";
  terminal.failed = false;
  terminal.creating = true;
  try {
    const { data } = await axios_instance.post("/api/v1/view/terminal/", {
      agent_id: clientId,
    });
    if (!data.action_id) throw new Error("Missing terminal action ID");
    terminal.actionId = data.action_id;
  } catch {
    terminal.failed = true;
  } finally {
    terminal.creating = false;
  }
}

function resetTerminal() {
  terminal.actionId = "";
  terminal.creating = false;
  terminal.failed = false;
  activeTab.value = "history";
}

const show_cmd_info = async (cmd_id: string | undefined) => {
  if (!cmd_id) return;

  await cmd_store.get_cmd_info(cmd_id);
  const cmd_result_modal = document.getElementById(
    "cmd_result_modal",
  ) as HTMLDialogElement;
  if (cmd_result_modal) {
    cmd_result_modal.showModal();
  }
};
</script>
